import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import attendanceReducer from "./slices/attendanceSlice";
import attendanceSummaryReducer from "./slices/attendanceSummarySlice";
import todayAttendanceReducer from "./slices/todayAttendanceSlice";
import adminEmployeeReducer from "./slices/adminEmployeeSlice";
import onboardingReducer from "./slices/onboardingSlice";
import employeeDocumentsReducer from "./slices/employeeDocumentsSlice";
import themeReducer from "./slices/themeSlice";

export const makeStore = () =>
  configureStore({
    reducer: {
      auth: authReducer,
      attendance: attendanceReducer,
      attendanceSummary: attendanceSummaryReducer,
      todayAttendance: todayAttendanceReducer,
      adminEmployee: adminEmployeeReducer,
      onboarding: onboardingReducer,
      employeeDocuments: employeeDocumentsReducer,
      theme: themeReducer,
    },
  });

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
